import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { StudioProvider } from "@/context/StudioContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Pratiche from "@/pages/Pratiche";
import PraticaDetail from "@/pages/PraticaDetail";
import Clienti from "@/pages/Clienti";
import Collaboratori from "@/pages/Collaboratori";
import PortaleCliente from "@/pages/PortaleCliente";
import Impostazioni from "@/pages/Impostazioni";
import Preventivi from "@/pages/Preventivi";
import Modulistica from "@/pages/Modulistica";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="app-loading">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-800 border-t-transparent" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StudioProvider>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/portale/:token" element={<PortaleCliente />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/pratiche" element={<Pratiche />} />
              <Route path="/pratiche/:id" element={<PraticaDetail />} />
              <Route path="/clienti" element={<Clienti />} />
              <Route path="/collaboratori" element={<Collaboratori />} />
              <Route path="/impostazioni" element={<Impostazioni />} />
              <Route path="/preventivi" element={<Preventivi />} />
              <Route path="/modulistica" element={<Modulistica />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
        </StudioProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
